import { DASHBOARD_PAGE } from '@townsquare/config/routes';
import { DASHBOARDS_PATH } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const dashboardRoute = createSiteRoute({
	exact: true,
	name: DASHBOARD_PAGE,
	path: DASHBOARDS_PATH + '/:slug/:mode?',
	layout: 'expanded',
});
